@if (!isHidden) {
  <div role="contentinfo"
       class="td-wb-footer">
    <div class="td-wb-footer__content">
      <td-wb-footer-end class="td-wb-footer-end">
        <div class="td-wb-footer__social"
             role="navigation"
             aria-labelledby="td-wb-aria-social-title">
          <div id="td-wb-aria-social-title"
               class="td-wb-footer__social-item td-wb-footer__social-item-title"
               role="heading"
               aria-level="2"
               translate="tdWb.navigation.footer.social.HEADING"></div>
          <div class="td-wb-footer__social-item-links">
            <button class="td-wb-footer__social-item-link"
                    aria-label="twitter button"
                    tdWbIconButton
                    tdWbIconButtonSize="large"
                    [tdWbHref]="'tdWb.navigation.footer.social.TWITTER' | tdWbTranslate"
                    target="_blank">
              <td-wb-icon iconId="x" size="32" />
            </button>
            <button class="td-wb-footer__social-item-link"
                    aria-label="facebook button"
                    tdWbIconButton
                    tdWbIconButtonSize="large"
                    [tdWbHref]="'tdWb.navigation.footer.social.FACEBOOK' | tdWbTranslate"
                    target="_blank">
              <td-wb-icon iconId="facebook" size="32" />
            </button>
            <button class="td-wb-footer__social-item-link"
                    aria-label="instagram button"
                    tdWbIconButton
                    tdWbIconButtonSize="large"
                    [tdWbHref]="'tdWb.navigation.footer.social.INSTAGRAM' | tdWbTranslate"
                    target="_blank">
              <td-wb-icon iconId="instagram" size="32" />
            </button>
            <button class="td-wb-footer__social-item-link"
                    aria-label="youtube button"
                    tdWbIconButton
                    tdWbIconButtonSize="large"
                    [tdWbHref]="'tdWb.navigation.footer.social.YOUTUBE' | tdWbTranslate"
                    target="_blank">
              <td-wb-icon iconId="youtube" size="32" />
            </button>
            <button class="td-wb-footer__social-item-link"
                    aria-label="linkedin button"
                    tdWbIconButton
                    tdWbIconButtonSize="large"
                    [tdWbHref]="'tdWb.navigation.footer.social.LINKEDIN' | tdWbTranslate"
                    target="_blank">
              <td-wb-icon iconId="linkedin" size="32" />
            </button>
          </div>
        </div>
      </td-wb-footer-end>
      <td-wb-footer-start class="td-wb-footer-start">
        <div class="td-wb-footer__links"
             [attr.aria-label]="'tdWb.navigation.footer.title' | tdWbTranslate"
             role="navigation">
          <a class="td-wb-footer__link-item"
             rel="noopener"
             target="_blank"
             [attr.href]="'tdWb.navigation.footer.PRIVACY_AND_SECURITY.url' | tdWbTranslate"
             translate="tdWb.navigation.footer.PRIVACY_AND_SECURITY.label">
          </a>
          <a class="td-wb-footer__link-item"
             target="_blank"
             rel="noopener"
             [attr.href]="'tdWb.navigation.footer.LEGAL.url' | tdWbTranslate"
             translate="tdWb.navigation.footer.LEGAL.label">
          </a>
          <a class="td-wb-footer__link-item"
             rel="noopener"
             target="_blank"
             [attr.href]="'tdWb.navigation.footer.ACCESSIBILITY.url' | tdWbTranslate"
             translate="tdWb.navigation.footer.ACCESSIBILITY.label">
          </a>
          <ng-content select="[extraLinks]" />
        </div>
      </td-wb-footer-start>
    </div>
  </div>
}
